export default {
  namespaced: true,
  state: {
    notificationList: [],
  },
  mutations: {
    SET_NOTIFICATION(state, data) {
      state.notificationList = data;
    },
  },
  actions: {
    setNotification({ commit }, data) {
      commit('SET_NOTIFICATION', data);
    },
  },
};
